import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
import { ParallaxSection } from './ParallaxSection';
export function Hero() {
  return <section className="relative h-[1024px] px-4 flex items-center justify-center overflow-hidden" data-id="element-71">
      <ParallaxSection speed={-0.3} className="w-full" data-id="element-72">
        <div className="text-center max-w-5xl mx-auto" data-id="element-73">
          <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6 leading-[1.1]" data-id="element-74">
            The first EHR-integrated, <br className="hidden md:block" data-id="element-75" />
            <span className="text-white" data-id="element-76">AI-powered</span> biospecimen and{' '}
            <br className="hidden md:block" data-id="element-77" />
            deep-data marketplace.
          </h1>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-8 text-sm md:text-base" data-id="element-78">
            <div className="flex items-center gap-2" data-id="element-79">
              <span className="text-[#BDF074] text-2xl" data-id="element-80">▸</span>
              <span className="text-[#BDF074]" data-id="element-81">HIPAA Compliant</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-82">
              <span className="text-[#BDF074] text-2xl" data-id="element-83">▸</span>
              <span className="text-[#BDF074]" data-id="element-84">ISO Certified</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-85">
              <span className="text-[#BDF074] text-2xl" data-id="element-86">▸</span>
              <span className="text-[#BDF074]" data-id="element-87">Trusted Provenance</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-16" data-id="element-88">
            <Button size="lg" className="w-full sm:w-auto group" data-id="element-89">
              Investor Download
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-90" />
            </Button>
            <Button variant="secondary" size="lg" className="w-full sm:w-auto" data-id="element-91">
              Request Demo
            </Button>
          </div>
        </div>
      </ParallaxSection>
    </section>;
}